import Vue from 'vue';
import App from './App';
import Buefy from 'buefy';
import router from './router';
import 'buefy/dist/buefy.css';
import Clipboard from 'v-clipboard';

Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(router);
Vue.use(Clipboard);


new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
